function init() {}

init();
